import { jsx } from "react/jsx-runtime";
import React from "react";
var arrow_left_arrow_right_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { d: "M14.1716 6.2924 12.3431 4.436 13.7573 3 18 7.3077l-4.2427 4.3078-1.4142-1.4359 1.8284-1.8565H6V6.2924h8.1716zM9.8284 15.677l1.8285-1.8566-1.4142-1.4359L6 16.6923 10.2427 21l1.4142-1.4359-1.8284-1.8565H18V15.677H9.8284z" })];
};
export {
  arrow_left_arrow_right_default as default
};
